// extracted by mini-css-extract-plugin
export default {"dashboard-header":"style_dashboard-header__F5L8H","dashboard-settings":"style_dashboard-settings__3XZV-"};